import { gsap } from "gsap";

export const initHeader = () => {
	initMenuLineHover();
	initAnnouncementBar();
	initResponsiveHighlightLinesHeight();
	initMobileAnchorClickEvents();
};

const MENU_ITEM_SELECTOR = "#primary-navigation #mega-menu-header_nav > .mega-menu-item";
const SUBMENU_OFFSET = 15;

const toggleMenuLines = (item, expand) => {
	toggleVerticalLine(item, expand);
	toggleHighlightLine(item, expand);
};

const toggleVerticalLine = (item, expand) => {
	const verticalLine = item.querySelector(".menu-item-line.vertical-line");
	if (!verticalLine) return;

	const subMenu = item.querySelector(".mega-sub-menu");
	if (!expand || !subMenu) {
		verticalLine.style.height = "";
		return;
	}

	const extra = Math.max(0, subMenu.scrollHeight - SUBMENU_OFFSET);
	verticalLine.style.height = `calc(100% + ${extra}px)`;
};

const toggleHighlightLine = (item, expand) => {
	const highlightLine = item.querySelector(".menu-item-line.highlight-line");
	if (!highlightLine) return;

	const hasSubMenu = !!item.querySelector(".mega-sub-menu");
	let itemWidth = item.offsetWidth;
	let itemHeight = item.offsetHeight;

	// if the item has margin left or right, add that to the width
	const style = getComputedStyle(item);
	const marginLeft = parseFloat(style.marginLeft) || 0;
	const marginRight = parseFloat(style.marginRight) || 0;
	itemWidth += marginLeft + marginRight;
	highlightLine.style.width = expand ? `${itemWidth}px` : "";
};

const initMenuLineHover = () => {
	const menuItems = document.querySelectorAll(MENU_ITEM_SELECTOR);
	if (!menuItems.length) return;

	menuItems.forEach((item) => {
		item.addEventListener("pointerenter", () => toggleMenuLines(item, true));
		item.addEventListener("pointerleave", () => toggleMenuLines(item, false));
	});
};

const initAnnouncementBar = () => {
	const announcementBar = document.querySelector("#announcement-bar");
	if (!announcementBar) return;

	const closeButton = announcementBar.querySelector("#announcement-close-button");
	if (!closeButton) return;

	closeButton.addEventListener("click", (e) => {
		const maxAgeRaw = e.currentTarget.getAttribute("data-cookie-max-age");
		const maxAge = maxAgeRaw ? Number(maxAgeRaw) : null;

		setAnnouncementClosedCookie(maxAge);
		gsap.to(announcementBar, {
			height: 0,
			paddingTop: 0,
			paddingBottom: 0,
			marginTop: 0,
			marginBottom: 0,
			duration: 0.5,
			onComplete: () => {
				announcementBar.style.display = "none";
			},
		});
	});
};

const setAnnouncementClosedCookie = (maxAgeSeconds) => {
	const base = "announcement_closed=true; path=/; SameSite=Lax";

	if (Number.isFinite(maxAgeSeconds) && maxAgeSeconds > 0) {
		const maxAge = Math.floor(maxAgeSeconds);
		const expires = new Date(Date.now() + maxAge * 1000).toUTCString();
		document.cookie = `${base}; max-age=${maxAge}; expires=${expires}`;
		return;
	}

	// session cookie
	document.cookie = base;
};

const initResponsiveHighlightLinesHeight = () => {
	// const highlightLines = item.querySelectorAll(".menu-item-line.highlight-line");
	// if (!highlightLines.length) return;
	const menuItems = document.querySelectorAll(MENU_ITEM_SELECTOR);
	if (!menuItems.length) return;

	const breakpoint = 1024;

	const updateHighlightLines = () => {
		const isDesktop = window.innerWidth > breakpoint;
		menuItems.forEach((item) => {
			const highlightLine = item.querySelector(".menu-item-line.highlight-line");
			if (!highlightLine) return;

			if (isDesktop) {
				highlightLine.style.height = "";
				highlightLine.style.width = "";
			} else {
				const itemHeight = item.offsetHeight;
				highlightLine.style.height = `${itemHeight}px`;
			}
		});
	};
	updateHighlightLines();
	window.addEventListener("resize", updateHighlightLines);
};

const initMobileAnchorClickEvents = () => {
	const navRoot = document.querySelector("#primary-navigation #mega-menu-header_nav");
	if (!navRoot) return;

	const handleIconInteraction = (e) => {
		if (window.innerWidth > 1024) return;

		const icon = e.target.closest("button.dropdown-icon");
		if (!icon || !navRoot.contains(icon)) return;

		const parentItem = icon.closest(".mega-menu-item-has-children");
		if (!parentItem) return;

		e.preventDefault();
		e.stopImmediatePropagation();
		e.stopPropagation();

		const isExpanded = parentItem.classList.toggle("mega-toggle-on");
		icon.setAttribute("aria-expanded", isExpanded ? "true" : "false");
	};

	navRoot.addEventListener(
		"pointerdown",
		handleIconInteraction,
		true,
	);
};
